import TimesheetHtml from './templates/timesheet.html';

export function Timesheet () {
  return {
    restrict: 'E',
    templateUrl: TimesheetHtml,
    scope: {
      timesheet: '='
    }
  }
}